export var Scene = /*#__PURE__*/ function(Scene) {
    Scene[Scene["LandingPage"] = 0] = "LandingPage";
    Scene[Scene["MainPage"] = 1] = "MainPage";
    Scene[Scene["Lobby"] = 2] = "Lobby";
    Scene[Scene["Room"] = 3] = "Room";
    Scene[Scene["Game"] = 4] = "Game";
    Scene[Scene["DiscordLeaderboard"] = 5] = "DiscordLeaderboard";
    Scene[Scene["DiscordStore"] = 6] = "DiscordStore";
    Scene[Scene["DiscordAbout"] = 7] = "DiscordAbout";
    Scene[Scene["DiscordCareers"] = 8] = "DiscordCareers";
    Scene[Scene["DiscordChampionship25"] = 9] = "DiscordChampionship25";
    Scene[Scene["DiscordChampionship26"] = 10] = "DiscordChampionship26";
    Scene[Scene["DiscordCommunity"] = 11] = "DiscordCommunity";
    Scene[Scene["DiscordFAQ"] = 12] = "DiscordFAQ";
    Scene[Scene["DiscordPrivacyPolicy"] = 13] = "DiscordPrivacyPolicy";
    Scene[Scene["DiscordPatchNotes"] = 14] = "DiscordPatchNotes";
    Scene[Scene["DiscordProfile"] = 15] = "DiscordProfile";
    Scene[Scene["DiscordGifting"] = 16] = "DiscordGifting";
    Scene[Scene["DiscordValues"] = 17] = "DiscordValues";
    Scene[Scene["DiscordValuesExamples"] = 18] = "DiscordValuesExamples";
    Scene[Scene["DiscordTerms"] = 19] = "DiscordTerms";
    Scene[Scene["DiscordPressKit"] = 20] = "DiscordPressKit";
    Scene[Scene["DiscordRefundPolicy"] = 21] = "DiscordRefundPolicy";
    Scene[Scene["DiscordReplay"] = 22] = "DiscordReplay";
    Scene[Scene["DiscordMore"] = 23] = "DiscordMore";
    return Scene;
}({});
